import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileArrowLeftOut: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFileArrowLeftOut"><Path d="M8.41406 16L6.41406 18H12V20H6.41406L8.41406 22L7 23.4141L2.58594 19L7 14.5859L8.41406 16Z" fill="currentColor"/><Path d="M12 10H20V22H14V16H11.2422L7 11.7578L4 14.7578V2H12V10Z" fill="currentColor"/><Path d="M19.4141 8H14V2.58594L19.4141 8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFileArrowLeftOut;
